import React from 'react'

export default function Loader() {
          return (
                    <div className="flex flex-col justify-center items-center h-screen">
                              <span className="loading loading-spinner loading-lg"></span>
                    </div>
          )
}
